<div class="container" (scroll)="onScroll($event)">
  <div class="header">
    <img (click)="close()" id="chavron" src="assets/icons/chavron-right.svg" />
    <div class="heading-content">
      <div class="title">{{ moduleName }}</div>
      <div class="heading">{{ call?.callName }}</div>
    </div>
  </div>
  <div *ngIf="call?.callType !== 'CONVERSATIONAL'; else conversationalCall">
    <div class="description">
      <div class="content">
        <div class="thumbnail" *ngIf="call?.callThumbnail">
          <img [src]="call?.callThumbnail || 'assets/icons/donna.svg'" alt="" />
        </div>
        <div class="text">
          {{ call?.description }}
        </div>
      </div>
    </div>
    <div class="border-seprater"></div>
    <div *ngIf="!isCallDetailsLoading && iCallDetailWithQuestions">
      <!-- Designed According to Figma Call Details Side Pane -->
      <div class="average-score">
        <div class="heading">{{'reporting.AVERAGE_SCORE_LABEL' | transloco}}</div>
        <div class="details">{{'reporting.AVERAGE_SCORE_DETAIL' | transloco}}.</div>
        <div class="bar-container">
          <div class="progress-bar" *ngIf="
              calculateProgress(
                iCallDetailWithQuestions?.averageCallScore || 0,
                totalScore
              );
              let bar
            ">
            <div class="segment" *ngFor="let i of [].constructor(totalScore); let index = index"
              [class.filled]="index < bar.filled">
              <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                [style.width.%]="bar.partial * 100"></div>
            </div>
          </div>
        </div>
        <div class="score-container">
          <div class="achieved-score">
            {{
            iCallDetailWithQuestions.averageCallScore || 0 | number : "1.1-2"
            }}
          </div>
          <div class="total-score">&nbsp;/&nbsp;{{ totalScore }}</div>
        </div>
      </div>
      <div class="average-facts">
        <h4 class="heading">{{'reporting.AVERAGE_ANSWER' | transloco}}:</h4>
        <div class="question" *ngFor="
            let question of iCallDetailWithQuestions?.questionScores;
            let i = index
          ">
          <div class="qno">{{'reporting.Q_LABEL' | transloco}}{{ i + 1 }}</div>
          <div class="details">
            <div class="title-container">
              <div class="title">{{ question.questionName }}</div>
              <div class="percentage">{{ question.answeredCorrectly | number : "1.0-2"}}%</div>
            </div>
            <div class="bar-container">
              <div [ngStyle]="{
                  'grid-template-columns':
                    'repeat(' + (question.factCount || 0) + ', 1fr)'
                }" class="progress-bar" *ngIf="
                  calculateProgress(question.avgScore, question.factCount);
                  let bar
                ">
                <div class="segment" *ngFor="
                    let i of [].constructor(question.factCount || 0);
                    let index = index
                  " [class.filled]="index < bar.filled">
                  <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                    [style.width.%]="bar.partial * 100"></div>
                </div>
              </div>
            </div>
            <div class="score-container">
              <div class="details-link" (click)="scrollTo(question.questionUuid)">
                <span>-{{'reporting.DETAILS' | transloco}}</span>
                <img src="assets/icons/arrow/arrow-dowwn-black.svg" alt="" />
              </div>
              <div class="score">
                {{ question.avgScore | number : "1.0-2"}}&nbsp;/&nbsp;{{ question.factCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-seprater"></div>
      <div class="questions">
        <div
          *ngFor="let question of displayedQuestions; let i = index"
          [id]="question.questionUuid"
        >
          <app-question-fact
            [accountUuid]="accountUuid"
            [question]="question"
            [questionNumber]="questionNumber(question.questionUuid)"
            [isModal]="false"
            [call]="call"
            [moduleName]="moduleName"
            [moduleUuid]="moduleUuid"
          ></app-question-fact>
          <div class="border-seprater"></div>
        </div>
      </div>
      <!-- Floating Scroll Buttons -->
      <div class="floating-container">
        <div *ngIf="!isNavigated">
          <div class="question" (click)="scrollTo('chavron')">
            <img src="assets/icons/arrow/arrow-up.svg" alt="->" />
          </div>
          <div *ngFor="
              let question of iCallDetailWithQuestions?.questionScores;
              let i = index
            " class="question" (click)="scrollTo(question.questionUuid)"
            [ngClass]="{ active: question.questionUuid === activeId }">
            {{ ('reporting.Q_LABEL' | transloco) + (i + 1) }}
          </div>
        </div>
        <div *ngIf="isNavigated" class="vertical-loader">
          <app-three-dots-blinking-vertical></app-three-dots-blinking-vertical>
        </div>
      </div>
    </div>
    <div *ngIf="!isCallDetailsLoading && !iCallDetailWithQuestions" class="no-result">
      <div class="emoji-container">
        <img src="assets/icons/emoji_face-in-clouds.svg" alt="" />
      </div>
      <div class="text-container">
        <div>{{'reporting.NO_RESULT' | transloco}}!</div>
        <div>
          {{'reporting.NO_RESULT_TEXT' | transloco}}!
        </div>
      </div>
    </div>
    <div class="loader" *ngIf="isCallDetailsLoading">
      <app-three-dots-blinking></app-three-dots-blinking>
    </div>
  </div>

  <ng-template #conversationalCall>
    <div class="conversational">
      *{{'reporting.CONVERSATIONAL_CALL_MSG' | transloco}}.
    </div>
  </ng-template>
</div>